module.exports = __webpack_public_path__ + "media/images/screenshots/question_kinds-ba5cca45440f37627b119735cedbf910.png";